import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { AutocompleteControl } from 'components/_basic/Form/Autocomplete';
import { SUB_SECTOR_OPTIONS_DEU } from 'components/BusinessToolForm/constants/deu/industrySubSectorOptions_deu';
import { SUB_SECTOR_OPTIONS_ES } from 'components/BusinessToolForm/constants/es/industrySubSectorOptions_es';
import { SUB_SECTOR_OPTIONS } from 'components/BusinessToolForm/constants/industrySubSectorOptions';
import { SUB_SECTOR_OPTIONS_UA } from 'components/BusinessToolForm/constants/ua/industrySubSectorOptions_ua';

import {
  COMPANY_INDUSTRY_GROUP_FIELD_NAME,
  GLOBAL_FIELD_NAMES,
  INDUSTRY_FIELD_NAME,
  SECTOR_FIELD_NAME,
  SUB_SECTOR_FIELD_NAME,
  useGetGlobalInitialValues,
} from '../../form';
import { IIndustryDropdownProps as IProps } from '../types';

export const SubSectorDropdown: FC<IProps> = ({ id, disabled }) => {
  const globalInitialValues = useGetGlobalInitialValues();
  const { t, i18n } = useTranslation();
  const { control, setValue } = useFormContext();

  const sectorValue = useWatch({ name: SECTOR_FIELD_NAME });

  const getSubSectorOptions = (lang: string) => {
    switch (lang) {
      case 'de':
        return SUB_SECTOR_OPTIONS_DEU[sectorValue?.value as keyof typeof SUB_SECTOR_OPTIONS_DEU];
      case 'uk':
        return SUB_SECTOR_OPTIONS_UA[sectorValue?.value as keyof typeof SUB_SECTOR_OPTIONS_UA];
      case 'es':
        return SUB_SECTOR_OPTIONS_ES[sectorValue?.value as keyof typeof SUB_SECTOR_OPTIONS_ES];
      default:
        return SUB_SECTOR_OPTIONS[sectorValue?.value as keyof typeof SUB_SECTOR_OPTIONS];
    }
  };

  const fieldChangeHandler = () => {
    setValue(COMPANY_INDUSTRY_GROUP_FIELD_NAME, globalInitialValues[GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY_GROUP]);
    setValue(INDUSTRY_FIELD_NAME, globalInitialValues[GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY]);
  };

  if (sectorValue || getSubSectorOptions(i18n.language)?.length) {
    return (
      <Grid item xs={12}>
        <AutocompleteControl
          control={control}
          label={t('subsector')}
          id={id ?? SUB_SECTOR_FIELD_NAME}
          name={SUB_SECTOR_FIELD_NAME}
          options={getSubSectorOptions(i18n.language)}
          disabled={disabled}
          onChange={fieldChangeHandler}
          onFieldClear={fieldChangeHandler}
        />
      </Grid>
    );
  }

  return null;
};
